import React, { useEffect, useRef, useState } from 'react'
import { Dropdown } from "react-bootstrap";
import { Link } from 'react-router-dom';
import ErrorToast from '../ErrorToast';
import WarningToast from '../WarningToast';
import SuccessToast from '../SuccessToast';
import axios from '../../API/axios';
import MoreHorizSharpIcon from '@mui/icons-material/MoreHorizSharp';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import PersonRemoveAlt1SharpIcon from '@mui/icons-material/PersonRemoveAlt1Sharp';
import LinkOffSharpIcon from '@mui/icons-material/LinkOffSharp';
import { useTranslation } from "react-i18next";
import { Portal } from "../../components/Portal";



const MutualActions = ({ item, MutualListAll, fetchShortMutualList }) => {
    const sessionId = localStorage.getItem("sessionId");
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const { t } = useTranslation();
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
         const language = localStorage.getItem("Lang");

    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    //************************Block User  ************************//

    // const BlockUser = async (id) => {
    //     const formData = new FormData();
    //     formData.append("DeviceType", "Web");
    //     formData.append("sessionId", sessionId);
    //     formData.append("UserUid", uid);
    //     try {
    //         const res = await axios.post("User/BlockUser", formData, {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //             },
    //         });
    //         setToastMessage(res.data.message);
    //         setShowToast(true);
    //         getUserProfile()
    //         // });
    //     } catch (error) {
    //         if (error.response && error.response.status === 404) {
    //             setWarningToastMessage(error.response.data.message);
    //             setShowWarningToast(true);
    //         } else {
    //             setErrorToastMessage(error.response.data.message);
    //             setShowErrorToast(true);
    //         }
    //     }
    // };
    //************************Block User  ************************//

    //************************UnBlock User  ************************//

    // const unblockUser = async (id) => {
    //     const formData = new FormData();
    //     formData.append("DeviceType", "Web");
    //     formData.append("sessionId", sessionId);
    //     formData.append("UserUid", uid);
    //     try {
    //         const res = await axios.post("User/UnBlockUser", formData, {
    //             headers: {
    //                 "Content-Type": "multipart/form-data",
    //             },
    //         });
    //         setToastMessage(res.data.message);
    //         setShowToast(true);
    //         getUserProfile()
    //     } catch (error) {
    //         if (error.response && error.response.status === 404) {
    //             setWarningToastMessage(error.response.data.message);
    //             setShowWarningToast(true);
    //         } else {
    //             setErrorToastMessage(error.response.data.message);
    //             setShowErrorToast(true);
    //         }
    //     }
    // };
    //************************UnBlock User  ************************//
    const dropdownRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const toggleDropdown = () => {
        setShowDropdown(!showDropdown);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [dropdownRef]);


    //************************Unfollow User  ************************//
    const [showModal, setShowModal] = useState(false);

    const handleCloseModal = () => setShowModal(false);
    const handleShow = () => setShowModal(true);


    const unFollowUser = async () => {
        const responseData = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: item.userUid,
            langKey: language === "en" ? "" : language,
        };
        try {
            await axios.post(`UserFollow/UnfollowUser`, responseData).then((res) => {
                // toast.success("User Unfollowed");
                setToastMessage(res.data.message);
                setShowToast(true);
                setShowModal(false);
                MutualListAll()
                fetchShortMutualList()
            });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    //************************Unfollow User  ************************//


    //************************Disconnect Request   ************************//
    const [disconectshow, setDisconectShow] = useState(false);
    const DisconnectClose = () => {
        setDisconectShow(false);
    };
    const Disconnect = async (id) => {
        const data = {
            deviceType: "Web",
            sessionId: sessionId,
            userUID: item.userUid,
            langKey: language === "en" ? "" : language,
        };
        console.log(data);
        try {
            await axios
                .post("Connection/DisconnectUser", data)
                .then((resData) => {
                    console.log(resData);
                    setDisconectShow(!disconectshow);
                    //   toast.success(resData.data.message);
                    setToastMessage(resData.data.message);
                    setShowToast(true);
                    MutualListAll()
                    fetchShortMutualList()
                });
        } catch (e) {
            if (e.response && e.response.status === 404) {
                setWarningToastMessage(e.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(e.response.data.message);
                setShowErrorToast(true);
            }
        }
    };

    //************************Disconnect Request ************************//

    useEffect(() => {
        if (showModal) {
            document.body.style.overflow = 'hidden';
            document.documentElement.style.overflow = 'hidden';
            document.body.classList.add('modal-open'); // When a modal opens
        } else {
            document.body.style.overflow = 'unset';
            document.documentElement.style.overflow = '';
            document.body.classList.remove('modal-open'); // When a modal closes
        }
    }, [showModal]);
    return (
        <>
            <div
                className="postMenu pointer ms-auto mt-1"
                onClick={() => setShowDropdown(!showDropdown)}
            >
                <MoreHorizSharpIcon className="material-symbols-sharp ms-2" />
                {showDropdown && (
                    <Dropdown.Menu
                        show={showDropdown}
                        ref={dropdownRef}
                        className="InteractionModal"
                    >

                        {item?.isFollowedByYou === true &&
                            <Dropdown.Item as="button" className="dropdownList">
                                <div
                                    onClick={() => {
                                        handleShow();
                                    }}
                                // onClick={BlockUser}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="dropdownTxt f-14 redText">{t("Connections.Unfollow")}</span>
                                    </div>
                                    {/* <p className="f-12 dropdownPara">
                                        Unfollow User
                                    </p> */}
                                </div>
                            </Dropdown.Item>
                        }
                        {item?.isConnectedByYou && <>
                            <Dropdown.Item as="button" className="dropdownList">
                                <div
                                    onClick={() => {
                                        setDisconectShow(!disconectshow);
                                    }}
                                // onClick={BlockUser}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="dropdownTxt f-14 redText">{t("Connections.Disconnect")}</span>
                                    </div>
                                    {/* <p className="f-12 dropdownPara">
                                        Disconnect User
                                    </p> */}
                                </div>
                            </Dropdown.Item>
                            <Dropdown.Item as="button" className="dropdownList">
                                <Link
                                    to={`/Message/${item.userUid}`}
                                >
                                    <div className="d-flex align-items-center">
                                        <span className="dropdownTxt f-14">{t("Notifications.Messages")}</span>
                                    </div>
                                    {/* <p className="f-12 dropdownPara">
                                        Message User
                                    </p> */}
                                </Link>
                            </Dropdown.Item>
                        </>
                        }


                    </Dropdown.Menu>
                )}
            </div>


            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />


            {showModal && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd wlj-overlay-modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "flex" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6 className="wlj-modal-title--danger">
                                  <PersonRemoveAlt1SharpIcon className="material-symbols-sharp" />
                                  {t("modals.Are you sure you want to unfollow")}
                                </h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        handleCloseModal();
                                    }}
                                />
                            </div>

                            <div className="text-end mt-3 mb-3 px-3 d-flex justify-content-end wlj-modal-footer">
                                    <button
                                        type="button"
                                        className="wljDangerBtn"
                                        onClick={() => unFollowUser()}
                                    >
                                        <PersonRemoveAlt1SharpIcon />
                                        {t("Recommendations.Unfollow")}
                                    </button>
                            </div>

                            {/* <div className="col-md-12 text-end mt-4">
                <button
                  type="button"
                  className="mainBtn1"
                  onClick={UndoEndorseData}
                >
                  UnEndorse
                </button>
              </div> */}
                        </div>
                    </div>
                </div>
                </Portal>
            )}

            {disconectshow && (
                <Portal layer="modal">
                <div
                    className="modal fade show postAdd wlj-overlay-modal"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "flex" }}
                >
                    <div className="modal-dialog  modal-dialog-centered " role="document">
                        <div className="modal-content">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6 className="wlj-modal-title--danger">
                                    <LinkOffSharpIcon className="material-symbols-sharp" />
                                    {t("modals.Are you sure you want to Disconnect")}
                                </h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={() => {
                                        DisconnectClose();
                                    }}
                                />
                            </div>

                            <div className="text-end mt-3 mb-3 px-3 d-flex justify-content-end wlj-modal-footer">
                                <button
                                    type="button"
                                    className="wljDangerBtn"
                                    onClick={() => Disconnect()}
                                >
                                    <LinkOffSharpIcon />
                                    {t("modals.Yes")}
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
                </Portal>
            )}
        </>
    )
}

export default MutualActions